import React, { useState, useEffect, useMemo } from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import Footer from "../Footer";
import EventTable from "../Events/EventsTable";
import EventForm from "../Events/EventForm";
import { useGet } from "../../customHooks/useGet";
import { usePost } from "../../customHooks/usePost";
import { FaPlus, FaSearch } from "react-icons/fa";
import 'react-toastify/dist/ReactToastify.css';
import { ToastContainer, toast } from "react-toastify";

const API_BASE_URL = "https://ectech-software.com.ar/api/academy/events";

const FloatingButton = ({ onClick, icon, title, position }) => (
  <button
    className="btn position-fixed rounded-circle p-3 shadow-lg d-flex align-items-center justify-content-center"
    onClick={onClick}
    aria-label={title}
    title={title}
    style={{
      background: "linear-gradient(135deg, #007bff, #6610f2)",
      color: "white",
      fontSize: "1.5rem",
      border: "none",
      width: "60px",
      height: "60px",
      transition: "transform 0.2s ease, box-shadow 0.3s ease",
      zIndex: 1050,
      bottom: "20px",
      right: position === "add" ? "20px" : "90px",
    }}
    onMouseEnter={(e) => {
      e.currentTarget.style.transform = "scale(1.1)";
      e.currentTarget.style.boxShadow = "0px 0px 15px rgba(102, 16, 242, 0.6)";
    }}
    onMouseLeave={(e) => {
      e.currentTarget.style.transform = "scale(1)";
      e.currentTarget.style.boxShadow = "0px 4px 10px rgba(0, 0, 0, 0.2)";
    }}
  >
    {icon}
  </button>
);

function Eventos() {
  const { data: eventsData, loading, error, refetch } = useGet(`${API_BASE_URL}?page=0&size=10`);
  const { executePost } = usePost();
  const [events, setEvents] = useState([]);
  const [showForm, setShowForm] = useState(false);
  const [searchTerm, setSearchTerm] = useState("");
  const [showSearch, setShowSearch] = useState(false);
  const [showFloatingButtons, setShowFloatingButtons] = useState(true);
  useEffect(() => {
    if (eventsData?.content) {
      setEvents(eventsData.content);
    }
  }, [eventsData]);

  const handleCreateEvent = async (newEvent) => {
    try {
      const createdEvent = await executePost(API_BASE_URL, newEvent);
      toast.success("Evento Creado con éxito");
      if (!createdEvent?.id) throw new Error("No se recibió respuesta válida del servidor.");
      await refetch();
      setShowForm(false);
    } catch (error) {
      console.error("Error al crear el evento:", error);
      alert("Hubo un problema al crear el evento. Intenta nuevamente.");
    }
  };

  const filteredEvents = useMemo(() => {
    return events.filter(({ name }) =>
      name.toLowerCase().includes(searchTerm.toLowerCase())
    );
  }, [events, searchTerm]);

  return (
    <div className="container mt-4 pb-5">
      <h1 className="text-center">Gestión de Eventos</h1>

      {loading && <p className="alert alert-info text-center">Cargando eventos...</p>}
      {error && <p className="alert alert-danger text-center">Error al cargar eventos: {error.message}</p>}

      {!loading && !error && filteredEvents.length > 0 ? (
        
        <EventTable events={filteredEvents} setEvents={setEvents} setShowFloatingButtons={setShowFloatingButtons} refetch={refetch}
         />
      ) : (
        <p className="text-center text-muted">No hay eventos disponibles.</p>
      )}

      <div className="position-fixed bottom-4 end-0 d-flex flex-column align-items-end me-4 mb-3" style={{ zIndex: 1050 }}>
        {!showForm && (
          <FloatingButton
            onClick={() => setShowForm(true)}
            icon={<FaPlus size={24} />}
            title="Agregar nuevo evento"
            position="add"
          />
        )}

        
      </div>

      {showSearch && (
        <div className="mt-4">
          <input
            type="text"
            className="form-control"
            placeholder="Buscar evento..."
            value={searchTerm}
            onChange={(e) => setSearchTerm(e.target.value)}
          />
        </div>
      )}

      {showForm && (
        <div className="mt-4">
          <EventForm onSubmit={handleCreateEvent} setShowForm={setShowForm} />
        </div>
      )}
      <ToastContainer 
      position="top-right"
      autoClose={3000}
      hideProgressBar={false}
      newestOnTop
      closeOnClick
      rtl={false}
      pauseOnFocusLoss
      draggable
      pauseOnHover
      theme="colored"
    />

      <Footer />
      
    </div>
  );
}

export default Eventos;
